// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__96sxv","active":"styles_active__eb22j","auth":"styles_auth__j5G+C","btn":"styles_btn__BBHcf","left":"styles_left__hGE3X","content":"styles_content__u7UsK"};